export default __webpack_public_path__ + "static/trustify-success-s-ae9e3a447987b3bb7ace65545c9bd9f5.png";